import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../store";
import { configurationApi } from "../../api/configurationApi";
import { AccentColorPayload, AppDesign } from "../../types/configurationType";
import { handleRequest } from "../utils/handleRequest";
import { CallResult } from "../../api/Requests";
import i18n from "../../i18n";

export const fetchAppDesignThunk = createAsyncThunk<
  Partial<AppDesign>,
  void,
  { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
  "configuration/appDesign",
  async (_, { dispatch, rejectWithValue }) => {
    const res = await handleRequest(
      dispatch,
      "indirect",
      () => configurationApi.getAppDesignData()
    );
    if (!res.success()) {
      return rejectWithValue(res.errorMessage ?? "Failed to fetch app design");
    }
    return res.result as Partial<AppDesign>;
  }
);

export const companyLogoUploadThunk = createAsyncThunk<
  CallResult<any>,
  void,
  { dispatch: AppDispatch; state: RootState }
>(
  "configuration/appDesign/uploadLogo",
  async (_, { dispatch, getState }) => {
    const state = getState();
    const { companyLogoBase64 } = state.configuration.appDesign;

    return await handleRequest(
      dispatch,
      "direct",
      () => configurationApi.uploadCompanyLogo(companyLogoBase64 ?? null),
      i18n.t("requestMessage.companyLogoUpdated")
    );
  }
);

export const editAccentColorThunk = createAsyncThunk<
  CallResult<any>,
  void,
  { dispatch: AppDispatch; state: RootState }
>(
  "configuration/appDesign/editColor",
  async (_, { dispatch, getState }) => {
    const state = getState();
    const newCompanyColor: AccentColorPayload = {
      accentColor: state.configuration.appDesign.accentColor ?? null
    };

    return await handleRequest(
      dispatch,
      "direct",
      () => configurationApi.editAccentColor(newCompanyColor),
      i18n.t("requestMessage.accentColorUpdated")
    );
  }
);